import { ExceptionBaseProps, ExceptionEventData } from '../models/track-event.model';
import { EmtException } from '@sg/apps/new-admin/src/lib/modules/exceptions/types';

const exceptionBaseProps = (exception: EmtException): ExceptionBaseProps => {
  return {
    id: exception.id,
    tradeRef: exception['tradeRef'],
    subStatus: exception['settlementSubStatus'],
    primaryGroup: exception.primaryGroup,
    status: exception.status,
  };
};

const exceptionTrackEventNames = {
  cancel: 'exception_cancel_source',
  settle: 'exception_settle_source',
  viewInstruction: 'exception_view_instructions',
  split: 'exception_split_source',
  postpone: 'exception_postpone',
  amend: 'exception_amend_source',
};

export const getExceptionEventData = <T>(
  exception: EmtException,
  eventId: keyof typeof exceptionTrackEventNames,
  extras?: T
): ExceptionEventData<T> => {
  const event = exceptionTrackEventNames[eventId];

  if (!event) {
    new Error(`${eventId} is Invalid event`);
    return;
  }

  const baseProps = exceptionBaseProps(exception);
  const properties = Object.assign(baseProps, extras);

  return { event, properties };
};
